var _rect, _rect2, _rect3, _path, _path2, _line, _line2, _line3, _line4, _path3, _line5, _line6, _path4, _path5, _rect4, _rect5, _rect6, _path6, _path7, _line7, _line8, _line9, _line10, _path8, _line11, _line12, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 7.80273,
    width: 11.5,
    height: 15.6053,
    rx: 1.25,
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.34229,
    width: 7,
    height: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.93503,
    y: 6.88181,
    width: 5.13158,
    height: 1.02632,
    rx: 0.513158,
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 1.02632
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50378 5.34229C8.68273 5.34229 8.70553 6.25457 8.81957 6.71071H10.1879C10.302 6.25457 10.3248 5.34229 9.50378 5.34229Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05078 11.3284L5.73499 11.8416L7.10341 10.4731",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.78906,
    y1: 10.6572,
    x2: 13.947,
    y2: 10.6572,
    stroke: "#A3A3A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.78906,
    y1: 12.0259,
    x2: 13.947,
    y2: 12.0259,
    stroke: "#A3A3A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.78516,
    y1: 14.7632,
    x2: 13.9431,
    y2: 14.7632,
    stroke: "#A3A3A3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.78516,
    y1: 16.1313,
    x2: 13.9431,
    y2: 16.1313,
    stroke: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05078 19.5398L5.73499 20.053L7.10341 18.6846",
    stroke: "#A3A3A3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7.78906,
    y1: 18.8687,
    x2: 13.947,
    y2: 18.8687,
    stroke: "#A3A3A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.78906,
    y1: 20.2373,
    x2: 13.947,
    y2: 20.2373,
    stroke: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21878 14.9497L6.87891 16.6099",
    stroke: "#A3A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21875 16.6099L6.87893 14.9497",
    stroke: "#A3A3A3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 3.80273,
    width: 11.5,
    height: 15.6053,
    rx: 1.25,
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.34229,
    width: 7,
    height: 3,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.93503,
    y: 2.88181,
    width: 5.13158,
    height: 1.02632,
    rx: 0.513158,
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 1.02632
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50378 1.34229C5.68273 1.34229 5.70553 2.25457 5.81957 2.71071H7.18794C7.30199 2.25457 7.32483 1.34229 6.50378 1.34229Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05078 7.32841L2.73499 7.84157L4.10341 6.47314",
    stroke: "#A3A3A3"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 4.78906,
    y1: 6.65723,
    x2: 10.947,
    y2: 6.65723,
    stroke: "#A3A3A3"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 4.78906,
    y1: 8.02588,
    x2: 10.947,
    y2: 8.02588,
    stroke: "#A3A3A3"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 4.78516,
    y1: 10.7632,
    x2: 10.9431,
    y2: 10.7632,
    stroke: "#A3A3A3"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 4.78516,
    y1: 12.1313,
    x2: 10.9431,
    y2: 12.1313,
    stroke: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05078 15.5398L2.73499 16.053L4.10341 14.6846",
    stroke: "#A3A3A3"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 4.78906,
    y1: 14.8687,
    x2: 10.947,
    y2: 14.8687,
    stroke: "#A3A3A3"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 4.78906,
    y1: 16.2373,
    x2: 10.947,
    y2: 16.2373,
    stroke: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21878 10.9497L3.87891 12.6099",
    stroke: "#A3A3A3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21875 12.6099L3.87893 10.9497",
    stroke: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTasks);
export default __webpack_public_path__ + "static/media/double-tasks.db50cdd2bc0677423e65d565305f1cab.svg";
export { ForwardRef as ReactComponent };